import { UseFormReturn } from 'react-hook-form'

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

import { TextInput } from '@/components/atoms'

import { ProductModel } from '@/types/model/Product'

import { productFieldsConfig } from './productFieldsConfig'

interface SeoSectionProps {
  form: UseFormReturn<ProductModel.ProductFormData>
}

export const SeoSection = ({ form }: SeoSectionProps) => {
  const { control, watch } = form
  const formValues = watch()
  const { fields } = productFieldsConfig({ formValues })
  return (
    <div className="grid gap-4 lg:grid-cols-[minmax(0,1fr)_288px] lg:gap-6">
      <Card className="min-w-0">
        <CardHeader>
          <CardTitle>Search engine listing</CardTitle>
          <CardDescription>
            Add a title and description to see how this product might appear in a search engine
            listing.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <TextInput
            control={control}
            name="metaTitle"
            label="Page title"
            placeholder="e.g. Best wireless headphones 2024"
            rules={fields.metaTitle.rules}
          />

          <TextInput
            control={control}
            name="metaDescription"
            label="Meta description"
            multiline
            placeholder="Brief description for search results..."
            rules={fields.metaDescription.rules}
          />

          <div className="space-y-1.5">
            <TextInput
              control={control}
              name="metaKeywords"
              label="Meta keywords"
              placeholder="e.g. wireless, headphones, bluetooth"
              rules={fields.metaKeywords.rules}
            />
            <p className="text-sm text-text-2">Separate keywords with commas.</p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
